module.exports = __webpack_public_path__ + "static/assets/af02bfe244cded0b63202aa8d0a6ae5a.png";